import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'studystay_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(CONSENT_KEY)) {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try { localStorage.setItem(CONSENT_KEY, 'accepted'); } catch {}
    setVisible(false);
  };

  const handleDecline = () => {
    try { localStorage.setItem(CONSENT_KEY, 'declined'); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[200] p-4 sm:p-6">
      <div className="max-w-2xl mx-auto rounded-2xl border border-slate-200 bg-white shadow-2xl p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-slate-900 mb-1">
              Cookievoorkeuren
            </p>
            <p className="text-sm text-slate-600">
              StudyStay gebruikt functionele cookies voor het goed functioneren van de website.
              Lees ons{' '}
              <Link to="/cookies" className="text-[#5EABEB] underline hover:text-[#4A9FE6]">
                cookiebeleid
              </Link>{' '}
              voor meer informatie.
            </p>
          </div>
          <div className="flex gap-2 shrink-0">
            <button
              onClick={handleDecline}
              className="h-10 px-4 rounded-lg border border-slate-200 text-sm font-medium text-slate-600 hover:bg-slate-50 transition-colors"
            >
              Weigeren
            </button>
            <button
              onClick={handleAccept}
              className="h-10 px-5 rounded-lg bg-[#5EABEB] text-sm font-semibold text-white hover:bg-[#4A9FE6] transition-colors"
            >
              Accepteren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
